import React, { useState } from 'react';

export default function EditableLabel({ value, onChange, editable, required = false }) {
  const [editing, setEditing] = useState(false);
  const [inputVal, setInputVal] = useState(value);

  const handleBlur = () => {
    setEditing(false);
    if (inputVal.trim()) onChange(inputVal.trim());
  };

  if (!editable) return <span>{value}</span>;

  return editing ? (
    <input
      className="custom-field"
      type="text"
      autoFocus
      value={inputVal}
      onChange={e => setInputVal(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={e => {
        if (e.key === 'Enter') handleBlur();
      }}
    />
  ) : (
    <span onClick={() => setEditing(true)}>{value}</span>
  );
}
